/**
 * 権限ロール
 */
export class Role {
    /** 権限コード */
    code = ""
    /** 権限名 */
    name = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Role>) {
        Object.assign(this, init)
    }
}
